export default "__VITE_ASSET__DTzg9OZu__"